import React, {useEffect, useState} from 'react';

import Appointment from "./components/appointment/Appointment";
import BikeSharing from "./components/bikeSharing/BikeSharing";
import VehicleOwner from "./components/vehicleOwner/VehicleOwner";

import PreContingentChangeForm from "./components/PreContingentChangeForm";
import UserForm from "./components/UserForm";
import Notification from "../../../../components/Notification";
import OffCanvasHeader from "../../../../components/OffcanvasHeader";
// @ts-ignore
import t from "../../../../helpers/t";

import * as API from "./API";
import * as Helper from "./Helper";
import {setSettings} from "./API";
import {useSelector} from "inbooma-api";
import OffCanvasView from "../../../../components/OffCanvasView";

interface Props {
    dispatch: any,
    returnUrl: string,
    params: any
}
const OrderForm = (props: Props) => {
    const { dispatch, returnUrl, params } = props;
    const [initialized, setInitialized] = useState(false);
    const [settings, setSettings] = useState({...Helper.initialSettings,
        dispatch: dispatch,
        returnPath: returnUrl});
    // @ts-ignore
    const _order = useSelector(state => state["orders"].order);
    const onCloseNotificationHandler = () => {
        setNotification({
            ...notification,
            show: false
        });
    };
    const [notification, setNotification] = useState({
        message: "",
        show: false,
        link: "",
        linkContent: "",
        linkHandler: ""
    });
    const [shouldClose, setShouldClose] = useState(false);
    useEffect(() => {
        console.log(_order,'_order')
        if (_order.success === '' || !settings.orderPending) {
            return;
        }
        let clone: any = {...settings};
        if (_order.success === true) {
            clone.order = _order.data;
        } else {
            setNotification(
                {
                    message: "Failed to get order",
                    show: true,
                    link: "",
                    linkContent: "",
                    linkHandler: ""
                }
            );
            setTimeout(() => {
                setShouldClose(true);
            }, 2000);
        }
        clone.orderPending = false;
        clone.initialized = true;
        setSettings(clone);
    }, [_order]);

    useEffect(() => {
        if(settings.initialized){
            console.log("initialized");
            setInitialized(true);
        }
    }, [settings]);
    const initialize = () => {
        if(settings.orderPending || initialized){
            return;
        }
        let clone = {...settings};
        if (params.orderAdd) {
                clone.add = true;
            } else {
                clone.id = params.orderId;

            }
            setSettings(clone);

        //API.setSettings({settings:clone});
        if(clone.id !== null) {
            API.getOrder({settings:clone,setSettings:setSettings,setInitialized:setInitialized, setShouldClose:setShouldClose, setNotification: setNotification});
        } else {
            setInitialized(true);
        }
    }
    
    if(!initialized){
        initialize();
    }

    return (
        <>
            <div className={"off-canvas-wrapper"}>
            <div className="off-canvas position-right is-transition-overlap is-open" id="inb-off-canvas"
                 data-off-canvas="85mrb3-off-canvas" data-close-on-click="false" aria-hidden="false">
                 <div className='is-overlay-fixed is-visible'> </div>
                {notification.show &&
                <>
                    <Notification
                        message={notification.message}
                        onCloseHandler={onCloseNotificationHandler}
                        link={notification.link}
                        linkHandler={notification.linkHandler}
                        linkContent={notification.linkContent}
                    >
                    </Notification>
                </>
                }
                {initialized &&<><OffCanvasHeader
                    heading={(settings.id !== null?t('order')+' #' + settings.order.order_nbr:t('create_${a}',{a:t('order')}))}
                    item={{}}
                    dispatch={settings.dispatch}
                    noSaveButton={false}
                    saveButtonName={t('next_step')}
                    onCloseHandler={API.onCloseHandler}
                    shouldClose={shouldClose}
                    returnUrl={settings.returnPath}
                    isSaving={false}
                />
                {settings.preSelectContingentForm && initialized &&
                    <PreContingentChangeForm
                        settings={settings}
                        setSettings={setSettings}
                        key={"PreContingentChangeForm"}
                    />
                }
                </>}

                {settings.userForm  && !settings.preSelectContingentForm && initialized &&
                    <UserForm
                        settings={settings}
                        setSettings={setSettings}
                        key={"UserForm"}
                    />
                   }
                {!settings.userForm && !settings.preSelectContingentForm && initialized &&
                    <>
                    {settings.usedForm === "bikeSharing" &&
                        <BikeSharing
                            settings={settings}
                            setSettings={setSettings}
                            key={"BikeSharing"}
                        />
                    }
                    {settings.usedForm === "vehicleOwner" &&
                        <VehicleOwner
                            settings={settings}
                            setSettings={setSettings}
                            key={"VehicleOwner"}
                        />
                    }
                    {settings.usedForm === "appointment" &&
                        <Appointment
                            settings={settings}
                            setSettings={setSettings}
                            key={"Appointment"}
                        />
                    }
                </>
                }
            </div>
            </div>
        </>
    );
}

export default OrderForm;